export default __webpack_public_path__ + "static/media/scheduledDelivery.2213b1b6.svg";